/** Returns true if x is non-inclusively between min and max */
export const isBetween = (x: number, min: number, max: number) => {
  return x > min && x < max
}

/** Returns true if x is inclusively between min and max */
export const isInRange = (x: number, min: number, max: number) => {
  return x >= min && x <= max
}

export const clamp = (x: number, min: number, max: number) => {
  return Math.min(Math.max(x, min), max)
}

/** Round to a given number of decimal places (default 0). */
export const round = (x: number, decimals = 0): number => {
  const factor = 10 ** decimals
  return Math.round(x * factor) / factor
}
